<template>
  <div class="detail-items-table">
    <div class="detail-items-table-header text-color-gray flex px-20 py-10 text-14">
      <div class="items-table-c0">{{ $t('排名') }}</div>
      <div class="items-table-c1">{{ $t('饰品') }}</div>
      <div class="items-table-c2">{{ $t('磨损度') }}</div>
      <div class="items-table-c4">{{ $t('图案模板') }}</div>
      <div class="items-table-c5">{{ $t('换手数') }}</div>
      <div class="items-table-6">{{ $t('拥有者') }}</div>
      <div>{{ $t('操作') }}</div>
    </div>

    <div v-if="pageLoading && list.length <= 0" class="bg-white">
      <CommonLoading />
    </div>
    <template v-else>
      <div class="detail-items-table-content bg-white" style="height: 350px;
    text-align: center;line-height: 350px;color: #999;">磨损排行功能优化中，优化完成后将再次开放。</div>
      <!-- <div v-infinite-scroll="loadMore" class="detail-items-table-content bg-white" :infinite-scroll-delay="500">
        <div v-for="(item, index) in list" :key="item.asset.fingerprint" class="table-item flex h-105 items-center p-20" @click="viewDetail(item.asset.fingerprint)">
          <div class="items-table-c0">
            <rank :rank="index + 1"></rank>
          </div>
          <div class="items-table-c1">
            <img :src="item.img" class="w-100" alt="" />
          </div>
          <div class="items-table-c2">
            <div class="items-center">
              <div class="mb-3 w-200">
                <div class="text-color-gray text-14">{{ $t('磨损') }}:{{ item.asset.floatWear }}</div>
                <div class="w-181">
                  <wearbar :wear="item.asset.floatWear" />
                </div>
              </div>
              <div>
                <div v-if="item.asset?.stickers?.length > 0" class="sticker-list flex items-center">
                  <div v-for="(sticker, index) in item.asset.stickers" :key="index" class="mr-5 w-35 text-center">
                    <img :src="sticker.imgUrl" alt="" />
                    <div class="text-color-lightblue text-14">{{ parseInt((1 - sticker.wear) * 100) }}%</div>
                  </div>
                </div>
                <div v-if="item?.asset?.specialStyleAndFade" class="flex">
                  <div class="level-lable text-color-white h-18 rounded-[9px] px-10 leading-[18px]" :style="{ backgroundColor: item?.specialStyleColor }">
                    {{ item?.specialStyleZh }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="items-table-c4">
            {{ item.asset.paintSeed }}
          </div>
          <div class="items-table-c5">
            {{ item.tradeCount }}
          </div>
          <div v-if="item.owner">
            <div class="items-table-6 mb-5 flex items-center">
              <img class="mr-10 w-30 overflow-hidden rounded-full" :src="item.owner.avatar" alt="" />
              <div class="w-100 overflow-hidden text-ellipsis text-nowrap">{{ item.owner.nickname }}</div>
            </div>
            <div class="text-color-gray">{{ $t('更新时间') }}: {{ dayjs(item.updateTime * 1000).format('YYYY-MM-DD') }}</div>
          </div>
          <div v-if="item.owner">
            <a :href="localePath(`/inventory/${item.owner.steamToken}`)" target="_blank">
              <button class="border-primary text-color-primary h-36 w-120 rounded border" @click.stop="">{{ $t('查看TA的库存') }}</button>
            </a>
          </div>
        </div>
      </div> -->
    </template>

    <div v-if="dialogVisible">
      <itemInspect :item="detailData.item" :list="detailData.list" :dialog-visible="dialogVisible" @close="dialogVisible = false" />
    </div>
  </div>
</template>

<script setup>
import wearbar from '../../../components/common/wearbar.vue'
import itemInspect from '~/components/common/itemInspect.vue'
import rank from '~/components/common/rankLabel.vue'
import { getFingerPrint } from '~~/api/steam.js'
import { copy } from '#imports'
import dayjs from 'dayjs'

const props = defineProps({
  markethashname: {
    type: String,
    default: ''
  },
  list: {
    type: Array,
    default: []
  },
  pageLoading: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
})

let pageQuery = ref({
  pageNum: 1,
  pageSize: 10,
  hashName: props.markethashname
})

const dialogVisible = ref(false)
const detailData = reactive({
  list: [],
  item: {}
})

function copyPrint(content) {
  myMessage({
    message: copy(content)
  })
}
const emit = defineEmits(['loadMore'])

function loadMore() {
  emit('loadMore')
}

// 查看详情
function viewDetail(id) {
  getFingerPrint({
    id: id
  }).then(res => {
    detailData.item = res.data
    dialogVisible.value = true
  })
}
</script>

<style lang="scss" scoped>
.detail-items-table {
  .detail-items-table-header {
    background-color: #fff;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }

  .items-table-c0 {
    width: 35px;
  }
  .items-table-c1 {
    width: 110px;
  }
  .items-table-c2 {
    width: 215px;
  }
  .items-table-c3 {
    width: 221px;
  }
  .items-table-c4 {
    width: 106px;
  }
  .items-table-c5 {
    width: 92px;
  }
  .items-table-6 {
    width: 186px;
  }
}
</style>
